import { useState } from 'react'
import Image, { ImageProps } from 'next/image'

import { cn } from '@/lib/utils'

export type LazyImageProps = Omit<ImageProps, 'alt'> & { alt?: string }

const LazyImage = ({ alt, className, onLoad, ...props }: LazyImageProps) => {
  const [loaded, setLoaded] = useState(false)

  return (
    <Image
      className={cn(
        'transition-opacity duration-700 ease-in-out-cubic',
        { 'opacity-0': !loaded },
        className
      )}
      onLoad={(event) => {
        setLoaded(true)
        onLoad?.(event)
      }}
      loading="lazy"
      alt={alt || ''}
      {...props}
    />
  )
}

export default LazyImage
